// extracted by mini-css-extract-plugin
export default {"BoxButton":"BoxButton_BoxButton__VHjOd"};